
import { Injectable }       from '@angular/core';
import { EmailEstudo } from './email-estudo';
import { Observable }       from 'rxjs';
import { ServiceUtil } from '../util/service.util';
import { HttpService } from 'ems-oauth2-client';
import { map, catchError , publishReplay, refCount} from 'rxjs/operators';
import { UsuarioEmsVo } from '../util/usuario-ems-vo';


@Injectable()
export class EmailEstudoService extends ServiceUtil  {
    private url = '/sae/emailestudo';
    private filtro : EmailEstudo = new EmailEstudo();

    constructor(private http: HttpService) { super(); }

    // altera ou inclui EmailEstudo
    update(email : EmailEstudo): Observable<EmailEstudo> {
        let body = JSON.stringify(email);
        if(!email.id){
          return this.http.post(this.url, body)
            .pipe(map(response => <EmailEstudo> response),
                catchError(this.handleError),
                publishReplay(1),
                refCount());
        }else{
          return this.http.put(this.url + "/" + email.id , body)
            .pipe(map(response => <EmailEstudo> response),
               catchError(this.handleError),
               publishReplay(1),
               refCount());
        }
    }

    // deleta EmailEstudo
    deletar(grupo: EmailEstudo): Observable<EmailEstudo> {
      return this.http.delete(this.url + "/" + grupo.id)
        .pipe(map(response => response),
           catchError(this.handleError),
           publishReplay(1),
           refCount());
    }


    // filtra
    filtrar(filtro : EmailEstudo): Observable<EmailEstudo[]>{
      let colocaVirgula = false;

      let novaUrl = this.url  + "?filter={" ;
      if(filtro.codigoEstudoSocioEconomico){
       novaUrl += "codigoEstudoSocioEconomico:\"" + filtro.codigoEstudoSocioEconomico + "\"";
       colocaVirgula = true;
      }

      if(filtro.id){
        novaUrl += "id:\"" + filtro.id + "\"";
        colocaVirgula = true;
      }

      novaUrl +=  "}";

      return this.http.get(novaUrl)
              .pipe(map(response =>{
                  var result = response;
                  return <EmailEstudo[]> response;
              }),
               catchError(this.handleError),
               publishReplay(1),
               refCount());
    }

    // recupera por id
    getId(id : number): Observable<EmailEstudo> {
        return this.http.get(this.url + "/" + id)
                  .pipe(map(this.extractObjectData),
                     catchError(this.handleError),
                     publishReplay(1),
                     refCount());
    }

    recuperaEmailUsuarioLogado(idUsuario: number){
      return this.http.get("/auth/user/" + idUsuario + "?fields=email")
        .pipe(map (this.extractEmailData),
          catchError(this.handleError),
          publishReplay(1),
          refCount());  
    }

    // extrai lista da resposta http
    private extractListData(res: any) {
      return res as EmailEstudo[] ;
    }

    // extrai objeto da resposta http
    private extractObjectData(res: any) {
      return res as EmailEstudo ;
    }

    private extractEmailData(res: any) {
      return res as UsuarioEmsVo ;
    }



}
